import { Paper } from "@material-ui/core";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";

function Folder() {
    const [data, setDate] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);

    const columns = [
        { title: 'Nome', field: 'name' },
    ]
    return (
        <Paper>
            <MaterialTable
                title="Pastas"
                data={data}
                columns={columns}
                actions={[
                    {
                        icon: 'add',
                        tooltip: 'Adicionar pastas',
                        isFreeAction: true,
                        onClick: (event, rowData) => setOpenDialog(true)
                    }
                ]}
            />
        </Paper>
    );
}

export default Folder;